@let value = tooltip();
@if (value && value.length > 0) {
  <mat-icon [matTooltip]="value" matTooltipPosition="below">help_outline</mat-icon>
}
